import React, { useState, useEffect } from 'react';
import './Gustos2-V2.css';
import { useConfig } from '../context/ConfigContext';
import useMenuWebSocket from '../hooks/useMenuWebSocket';
import fondoGustos from '../assets/FondoGustos2.webp';
import logoHeladeria from '../assets/heladeria boutique.webp';

const Gustos2V2 = () => {
    const [categoriesWithFlavors, setCategoriesWithFlavors] = useState([]);
    
    const { config } = useConfig();
    
    // Hook WebSocket para actualizaciones en tiempo real
    const {
        flavorCategories,
        flavors,
        isConnected,
        isLoading,
        error,
        reconnect
    } = useMenuWebSocket(config?.shopBranchId);

    // Procesar datos WebSocket cuando cambien
    useEffect(() => {
        if (flavorCategories.length > 0 && flavors.length > 0) {
            console.log('=== PROCESANDO DATOS WEBSOCKET GUSTOS-2 ===');
            console.log('Categorías WebSocket:', flavorCategories);
            console.log('Gustos WebSocket:', flavors);

            // Filtrar solo elementos activos
            const activeCategories = flavorCategories.filter(category => category.status);
            const activeFlavors = flavors.filter(flavor => flavor.status);

            // Agrupar gustos por categoría
            const categoriesWithFlavorsData = activeCategories.map(category => {
                const categoryFlavors = activeFlavors.filter(flavor => 
                    flavor.flavorCategoryId === category.id
                );
                return {
                    ...category,
                    flavors: categoryFlavors
                };
            }).filter(category => category.flavors.length > 0); // Solo categorías con gustos

            // Ordenar categorías por displayOrder
            const sortedCategories = categoriesWithFlavorsData.sort((a, b) => {
                const orderA = a.displayOrder || 0;
                const orderB = b.displayOrder || 0;
                return orderA - orderB;
            });

            console.log('Categorías con gustos ordenadas:', sortedCategories);

            // Esta es la pantalla 2 - muestra desde la 4ta categoría en adelante
            const remainingCategories = sortedCategories.slice(3);

            console.log('Categorías restantes para gustos-2:', remainingCategories);

            setCategoriesWithFlavors(remainingCategories);
        }
    }, [flavorCategories, flavors]);



    if (isLoading) {
        return (
            <div 
                className="gustos2-v2-container"
                style={{
                    backgroundImage: `url(${fondoGustos})`
                }}
            >
                <div className="gustos2-v2-loading">
                    <div className="gustos2-v2-loading-spinner"></div>
                    <p>Conectando con el servidor...</p>
                </div>
            </div>
        );
    }

  

    return (
        <div 
            className="gustos2-v2-container"
            style={{
                backgroundImage: `url(${fondoGustos})`
            }}
        >
            <div className="gustos2-v2-header">
                <img src={logoHeladeria} alt="Heladería Boutique" className="gustos2-v2-logo" />
                <div className="gustos2-v2-divider-line"></div>
            </div>
            <div className="gustos2-v2-content">
                {categoriesWithFlavors.length === 0 ? (
                    <div className="gustos2-v2-empty">
                        <p>No hay gustos disponibles</p>
                    </div>
                ) : (
                    <div className="gustos2-v2-categories-list">
                        {categoriesWithFlavors.map((category) => (
                            <div key={category.id} className="gustos2-v2-category-group">
                                <h2 className="gustos2-v2-category-name">{category.name}</h2>
                                {category.flavors.map((flavor) => (
                                    <div key={flavor.id} className="gustos2-v2-flavor-name">
                                        {flavor.name}
                                    </div>
                                ))}
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default Gustos2V2;